import {
  FormDatePicker,
  FormInput,
  FormSectionHeader,
  FormSelect,
  FormTextarea,
  Loader,
} from "@/components";
import useProjectBasicDtl from "./useProjectBasicDtl";
import { FormProvider } from "react-hook-form";
import {
  ADDRESS,
  DESCRIPTION,
  ESTIMATED_END_DATE,
  ESTIMATED_START_DATE,
  NAME,
  PROJECT_CATEGORY_ID,
  PROJECT_ID,
  PROJECT_VALUE,
} from "./consts";

const ProjectBasicDtl = () => {
  const {
    form,
    requiredFields,
    keys,
    projectCategoryList,
    isLoadingProjectCategory,
    isProjectDataLoading,
  } = useProjectBasicDtl();
  const { errors } = form.formState;

  return isLoadingProjectCategory || isProjectDataLoading ? (
    <Loader />
  ) : (
    <FormProvider {...form}>
      <form>
        <div className="bg-white mt-[20px] rounded-lg shadow-sm overflow-hidden px-[30px] py-[25px]">
          <FormSectionHeader>Basic Details</FormSectionHeader>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
            <FormInput
              name={NAME}
              control={form.control}
              label="Project Name"
              placeholder="Please enter"
              error={errors[NAME]?.message}
              isRequired={requiredFields.includes(NAME)}
              disabled
            />
            <FormInput
              name={PROJECT_ID}
              control={form.control}
              label="Project Code/ID"
              placeholder="Please enter"
              error={errors[PROJECT_ID]?.message}
              isRequired={requiredFields.includes(PROJECT_ID)}
              disabled
            />
            <FormSelect
              key={keys.projectCategoryList}
              name={PROJECT_CATEGORY_ID}
              control={form.control}
              label="Project Category"
              placeholder="Please enter"
              error={errors[PROJECT_CATEGORY_ID]?.message}
              isRequired={requiredFields.includes(PROJECT_CATEGORY_ID)}
              options={(projectCategoryList?.data || [])?.map((data: any) => ({
                label: data?.catName,
                value: data?.projectCategoryId?.toString(),
              }))}
              disabled
            />
            <FormDatePicker
              name={ESTIMATED_START_DATE}
              control={form.control}
              label="Estimated Start Date"
              placeholder="Please select"
              error={errors[ESTIMATED_START_DATE]?.message}
              isRequired={requiredFields.includes(ESTIMATED_START_DATE)}
              minDate={new Date()}
              onClear={() => form.setValue(ESTIMATED_START_DATE, "")}
              disabled
            />
            <FormDatePicker
              name={ESTIMATED_END_DATE}
              control={form.control}
              label="Estimated End Date"
              placeholder="Please select"
              error={errors[ESTIMATED_END_DATE]?.message}
              isRequired={requiredFields.includes(ESTIMATED_END_DATE)}
              minDate={form.watch(ESTIMATED_START_DATE)}
              onClear={() => form.setValue(ESTIMATED_END_DATE, "")}
              disabled
            />
            {/* <FormInput
              name={CLIENT_NAME}
              control={form.control}
              label="Client Name"
              placeholder="Please enter"
              error={errors[CLIENT_NAME]?.message}
              isRequired={requiredFields.includes(CLIENT_NAME)}
              disabled
            /> */}
            <FormInput
              name={PROJECT_VALUE}
              control={form.control}
              label="Project Value(Budget)"
              placeholder="Please enter"
              error={errors[PROJECT_VALUE]?.message}
              isRequired={requiredFields.includes(PROJECT_VALUE)}
              disabled
            />
            <div className="col-span-2">
              <FormInput
                name={ADDRESS}
                control={form.control}
                label="Address"
                placeholder="Please enter"
                error={errors[ADDRESS]?.message}
                isRequired={requiredFields.includes(ADDRESS)}
                disabled
              />
            </div>
            <div className="col-span-2">
              <FormTextarea
                name={DESCRIPTION}
                control={form.control}
                label="Description"
                placeholder="Please enter"
                error={errors[DESCRIPTION]?.message}
                isRequired={requiredFields.includes(DESCRIPTION)}
                disabled
              />
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default ProjectBasicDtl;
